export default function BadgesIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M436.79,353.15l-66.74-100.27c8.61-17.64,13.45-37.46,13.45-58.38,0-73.61-59.89-133.5-133.5-133.5S116.5,120.89,116.5,194.5c0,20.9,4.83,40.69,13.42,58.32l-66.78,100.33c-9.69,14.56,3.34,33.48,20.39,29.63l52.76-11.93,9.16,53c2.98,17.25,25.5,22.01,35.2,7.43l68.75-103.28.57-.86.56.86,68.75,103.28c9.7,14.58,32.23,9.82,35.21-7.43l9.15-53,52.76,11.93c17.05,3.85,30.08-15.07,20.39-29.63ZM167.67,405.66l-11.22-64.99-64.7,14.62,52.69-79.16c18.85,24.33,45.9,41.98,76.98,48.79l-53.75,80.74ZM250,303c-2.1,0-4.19-.06-6.27-.18-44.45-2.54-81.83-31.97-96.06-72.24-4-11.29-6.17-23.44-6.17-36.08,0-59.83,48.67-108.5,108.5-108.5s108.5,48.67,108.5,108.5c0,12.62-2.17,24.75-6.15,36.02-14.22,40.32-51.64,69.79-96.15,72.3-2.05.12-4.12.18-6.2.18ZM343.48,340.67l-11.22,64.99-53.73-80.73c31.08-6.79,58.14-24.44,76.99-48.75l52.66,79.11-64.7-14.62Z"/>
    </svg>
  );
}
